<mat-form-field class="full-width">
    <mat-label>{{ label | translate }}</mat-label>
    <input #InputTextField
           id="{{idPrefix}}input_text_clipboard.{{idSuffix}}"
           type="text" matInput
           [(ngModel)]="bananaBox"
           [disabled]="disabled"
           [readonly]="readonly">
    <button id="{{idPrefix}}input_text_clipboard.{{idSuffix}}.btn.copy"
            mat-button
            matSuffix mat-icon-button
            (click)="copy()"
            [disabled]="disabled">
        <mat-icon>
            <i class="far fa-copy"></i>
        </mat-icon>
    </button>
</mat-form-field>
